
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import type { CourseRecordCardUIType } from '@xt/client/entities/my-v2/types'
import { EnumBizType } from '@xt/client/enums/homework/index'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class CourseRecordCard extends Vue {
  @Prop() dataSource: CourseRecordCardUIType

  get tipText() {
    const { bizType, studyType } = this.dataSource

    if (bizType === EnumBizType.Activity) {
      return '打卡'
    } else if (bizType === EnumBizType.Show) {
      return '闯关'
    } else {
      return studyType === 1 ? '观看课程' : '交作业'
    }
  }

  goCourse() {
    const { bizType, bizId } = this.dataSource

    if (bizType === EnumBizType.Activity) {
    } else if (bizType === EnumBizType.Show) {
    } else {
      this.$router.push({
        name: 'course-id',
        params: { id: bizId.toString() }
      })
    }
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
